<template><div><h1 id="post-bundzettel-drucken-exportieren" tabindex="-1"><a class="header-anchor" href="#post-bundzettel-drucken-exportieren"><span>Post-Bundzettel drucken, exportieren</span></a></h1>
<p>Post-Bundzettel drucken, exportieren — Druckt/exportiert Bundzettel für grosse Postversände</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient dem Drucken der Bundzettel und des Aufgabeprotokolls bei der Sortierung nach Botenfile. Die Aufbereitung der benötigten Dokumente für die Post geschieht in zwei Schritten: Zuerst werden die Bundzettel gedruckt. Die Adressen im Filter müssen bereits botenroutiert und markiert sein.</p>
<p>Nach diesem Schritt kann das <RouteLink to="/referenz/refs/ft.refproc.postbzprot.html" title="Post-Bundzettel Aufgabeprotokoll">Aufgabeprotokoll</RouteLink> erstellt.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Adressen → Datenausgabe → Post-Bundzettel (nach Filter) → Post-Bundzettel drucken, exportieren</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<dl>
<dt>Adressfilter</dt>
<dd>Filternummer, welche die gewünschten Adressen selektiert</dd>
<dt>Aufgabepoststelle</dt>
<dd>Auswahl der Poststelle aus der Tabelle</dd>
<dt>Bundzettelformat</dt>
<dd>Auswahl des Formates, z.B. 23 Zeilen oder 35 Zeilen usw.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Beispiel:</p>
<pre><code>                                                       ARENAE Consulting AG
                                                       Freiestrasse 18
                                                       8032 Zürich


                                                       AZB 8026 Zürich

     \*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*
     \*                                               \*
     \*   Poststelle:                                 \*
     \*                                               \*
     \*   96 WIL SG DG                                \*
     \*                                               \*
     \*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*\*

                                   BundNr.....:   1289
                                   Exempl.im B:     27
</code></pre>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>gem. Parameter</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


